import { type IDistrictState } from "./district.interface";

export const districtInitialState: IDistrictState = {
  items: [],
  selectedDistrict: null,
};

